import { render } from '@solidjs/web';

import { appConfigService } from '~/core/app-config';
import { authService } from '~/core/auth.service';
import { stateService } from '~/core/state.service';
import { useLang } from '~/lib/i18n';
import './styles/index.css';

/**
 * Bootstrap: runtime config.json (env-driven) first, then the session, then the
 * persisted language — all before the first render so guards and the first
 * paint see resolved state (the Angular app initializers' order).
 */
async function bootstrap(): Promise<void> {
  await appConfigService.load();
  await authService.loadSession();
  await useLang(stateService.lang());
  const { default: App } = await import('./App');
  render(() => <App />, document.getElementById('root')!);
}

// Last-resort logging for errors that escape every boundary.
window.addEventListener('unhandledrejection', (e) => console.error(e.reason));

void bootstrap();
